/*eslint-disable*/
import * as React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@mui/material/List";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

// Images
// import Image from "@mui/material/Image";
import canonEOS from "assets/img/equipment-pics/Camera/Canon EOS R5 C Body, Full-Frame, Hybrid, Mirrorless Digital Cinema Camera.jpg";
import canonRF from "assets/img/equipment-pics/Camera/Canon RF 24-105mm f_4L IS USM Lens.jpg";
import glideGear from "assets/img/equipment-pics/Camera/Glide Gear TMP100 Adjustable iPad_ Tablet_ Smartphone Teleprompter.jpg";
import prompter from "assets/img/equipment-pics/Camera/Prompter People Flex Plus 12 Teleprompter with 12_ Reversing Monitor.jpg";
import seetec4k156 from "assets/img/equipment-pics/Camera/SEETEC 4K156-9HSD 15.6 Inch Broadcast LCD Monitor with IPS UHD 3840x2160 SDI Input and Output 4xHDMI Inputs Quad Split Display.jpg";
import sigmaF1 from "assets/img/equipment-pics/Camera/Sigma F1.4 Art Set 24mm, 35mm, 50mm, 85mm for Canon EF.jpg";
import sonyCinema from "assets/img/equipment-pics/Camera/SONY Cinema Line FX30 Super 35 Camera.jpg";
import sonyFE50mm from "assets/img/equipment-pics/Camera/Sony FE 50mm F1.4 GM Lens.jpg";
import sonyFEPZ28 from "assets/img/equipment-pics/Camera/Sony FE PZ 28-135mm f_4 OSS G Lens.jpg";
import sonyFX6 from "assets/img/equipment-pics/Camera/Sony FX6 Full-Frame Cinema Camera.jpg";
import venusOptics from "assets/img/equipment-pics/Camera/Venus Optics 100mm T2.9 2x Macro APO FF Cine Lens (Canon EF).jpg";

// core components

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

import Collapse from "@mui/material/Collapse";
import { ListItemText } from "@material-ui/core";
import { Grid, ListItemButton } from "@mui/material";

const useStyles = makeStyles(styles);
const textStyle = { color: "#3C4858" };
const imgHeight = "100px";
const IMAGES = {
  "Canon EOS R5 C Body - Full-Frame": canonEOS,
  "Canon RF 24 - 105mm": canonRF,
  "Glide Gear TMP100 iPad Teleprompter": glideGear,
  "Prompter People Flex Plus 12 Teleprompter": prompter,
  "SEETEC 4K156-9HSD 15.6\" Broadcaster LCD Monitor": seetec4k156,
  "Sigma F1.4 Art Set 24mm, 35mm, 50mm, 85mm for Canon EF": sigmaF1,
  "Sony Cinema Line FX30 Super 35": sonyCinema,
  "Sony FE 50mm F1.4 GM Lens": sonyFE50mm,
  "Sony FE PZ 28-135mm OSS G Lens": sonyFEPZ28,
  "Sony FX6 Full-Frame Cinema Camera": sonyFX6,
  "Venus Optics 100mm T2.9 2x Macro APO FF Cine Lens": venusOptics
};

export default function CameraEquipment(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleEquipmentClick = () => {
    setOpen(!open);
  };
  const EQUIPMENTLIST = ({ items }) =>
    Object.entries(items).map(([k, v]) => (
      <Grid item xs={12} sm={6} md={4} lg={3} textAlign="center">
        <ListItemText
          primary={k}
          style={textStyle}
          className={classes.description}
        />
        <img src={v} height={imgHeight} />
      </Grid>
    ));
  return (
    <List>
      <ListItemButton onClick={handleEquipmentClick}  style={{ backgroundColor: "#3c85b3" }} >
        <ListItemText
          primary="Cameras"
          style={{ color: "#FFFFFF", borderBottom: 1, borderColor: "primary" }}
          className={classes.description}
        />
        {open ? (
          <ExpandLess style={{ color: "#FFFFFF" }} />
        ) : (
          <ExpandMore style={{ color: "#FFFFFF" }} />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto">
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <EQUIPMENTLIST items={IMAGES} />
        </Grid>
      </Collapse>
    </List>
  );
}
